import { CachedImage } from '@common/ui/CachedImage';

import styles from './FeedActions.module.scss';

export type FeedActionsProps = {
  /** For an observer: whether the row is on screen. */
  rootRef?: React.Ref<HTMLDivElement>;
  /** The middle button; a card that can't get a superlike has two (board A.4). */
  superlikeButton?: React.ReactNode;
  onPass: () => void;
  onLike: () => void;
};

/** The feed's buttons under the photo (board A.3): pass, superlike, like. */
export const FeedActions = ({
  rootRef,
  superlikeButton,
  onPass,
  onLike,
}: FeedActionsProps) => (
  <div ref={rootRef} className={styles.feedActions} data-test-id="feed-actions">
    <div className={styles.cell}>
      <button
        type="button"
        className={styles.button}
        aria-label="Дизлайк"
        data-action="pass"
        data-test-id="feed-actions-pass-button"
        onClick={onPass}
      >
        <CachedImage
          testId="feed-actions-pass-icon"
          src="/icons/3d-icons/dislike.png"
          alt=""
          blur="2px"
          className={styles.icon}
        />
      </button>
    </div>

    {superlikeButton && <div className={styles.cell}>{superlikeButton}</div>}

    <div className={styles.cell}>
      <button
        type="button"
        className={styles.button}
        aria-label="Лайк"
        data-action="like"
        data-test-id="feed-actions-like-button"
        onClick={onLike}
      >
        <CachedImage
          testId="feed-actions-like-icon"
          src="/icons/3d-icons/like.png"
          alt=""
          blur="2px"
          className={styles.icon}
        />
      </button>
    </div>
  </div>
);
